import React, { useState } from 'react';
import ShareChildrenStep1 from './ShareChildrenStep1';
import ShareChildrenStep2 from './ShareChildrenStep2';

interface Props {
	childrenId: string;
	setModalTitle: (title: string) => void;
	onSuccess: () => void;
}

export interface PickedFamilyMember {
	id: string;
	profileImageUrl: string;
	fullName: string;
}

const ShareChildrenWrapper: React.FC<Props> = ({
	setModalTitle,
	onSuccess,
	childrenId,
}) => {
	const [pickedFamilyMember, setPickedFamilyMember] = useState<
		PickedFamilyMember | undefined
	>(undefined);

	if (pickedFamilyMember) {
		setModalTitle('component.shareChildren.step2.title');
		return (
			<ShareChildrenStep2
				onCancel={() => setPickedFamilyMember(undefined)}
				onSuccess={onSuccess}
				childrenId={childrenId}
				pickedFamilyMember={pickedFamilyMember}
			/>
		);
	}

	setModalTitle('component.shareChildren.step1.title');
	return (
		<ShareChildrenStep1
			onSelect={(familyMember: PickedFamilyMember) =>
				setPickedFamilyMember(familyMember)
			}
			childrenId={childrenId}
			onSuccess={onSuccess}
		/>
	);
};

export default ShareChildrenWrapper;
